import { useMemo } from 'react';
import { TRADE_FLOW_FIGMA_LINK, organizationsConfig } from '@/constants';
import { useCurrentUser } from '@/core/hooks/useCurrentUser';
import { isNewLines9MayOrgId, isNewLines13JuneOrgId } from '@/utils/isNewLinesOrgId';

interface DemoActions {
  figmaLink?: string;
  actionMenuLink?: string;
  withDocsButtons?: boolean;
}

// TODO: Demo purpose, all logic in one place, should be removed in the future
export const useDemoActionMenu = (): DemoActions => {
  const currentUser = useCurrentUser();
  const organizationsConfigMap = useMemo(
    () => new Map(organizationsConfig.map((item) => [item.id, item])),
    [organizationsConfig],
  );
  const actionMenuLink = useMemo(
    () => organizationsConfigMap.get(currentUser.orgId)?.actionLink,
    [currentUser?.orgId, organizationsConfigMap],
  );
  const isNewLines9MayOrg = useMemo(() => isNewLines9MayOrgId(currentUser?.orgId), [currentUser?.orgId]);
  const isNewLines13JuneOrg = useMemo(() => isNewLines13JuneOrgId(currentUser?.orgId), [currentUser?.orgId]);
  const figmaLink = useMemo(() => {
    if (isNewLines13JuneOrg) {
      return TRADE_FLOW_FIGMA_LINK;
    }
    return undefined;
  }, [isNewLines13JuneOrg]);

  return {
    figmaLink,
    actionMenuLink,
    withDocsButtons: isNewLines9MayOrg,
  };
};
